import React from 'react';
import { Content } from '../../../infrastructure/content';
import { ActionAnchor } from 'web-ui-components/lib/actions/anchors';

const Download = ({ pdfRef }) => (
  <Content>
    {({ personalInformationDownloadLabel = '' }) => (
      <ActionAnchor.Download href={pdfRef} labelText={personalInformationDownloadLabel} />
    )}
  </Content>
);
export default Download;
